/* ==========================================================================
   LOVI — LOT 20 (08/08/2026) — assets/lovi-lot20.js
   --------------------------------------------------------------------------
   Cible : theme 198820397383 « LOVI V11 », role UNPUBLISHED.
   Verifie avant poussee : themes(roles:[MAIN]) = 198702203207.

   Charge par snippets/custom-code-body.liquid, en toute fin de <body>, apres
   lovi-lot18.js. Deux fonctions, aucune autre.

     A. GARDE-FOU DE LA DATE DE LIVRAISON.
        La date est rendue cote serveur, en Liquid, dans
        sections/lovi-pdp-buybox.liquid (104 Ko). Ce fichier n'a pas ete relu
        — donc l'algorithme Liquid n'est pas verifie — mais la sortie du jour
        l'est : samedi 08/08/2026 affiche « mercredi 12/08 », et 12/08/2026
        est bien un mercredi et un jour ouvre. Le defaut deja rencontre sur ce
        dossier est un affichage tombant un dimanche. Ce garde-fou relit la
        valeur rendue et ne la corrige QUE si elle tombe un samedi ou un
        dimanche, ou si le nom du jour ne correspond pas a la date. Il n'y a
        donc pas deux sources de verite : le serveur reste la source, le JS
        n'intervient que sur une valeur invalide.

     B. INVARIANT D'UN SEUL PALIER SELECTIONNE.
        La mesure a montre que le JS existant est deja correct
        ([data-lpdp-pack].is-selected vaut toujours 1 apres chaque clic) et
        que le bug etait purement CSS — voir le point 4 de lovi-lot20.css.
        Ce filet ne change donc rien au comportement observe ; il garantit
        l'invariant si un autre lot venait a le casser. Il s'applique aussi au
        chemin du quiz, qui passe par packs[idx].click().

   Aucun hook touche : data-lpdp-pack, data-variant-id, data-gifts,
   data-unlock, data-price-text, data-compare-text, .is-selected, .is-locked,
   __loviAtcPrice, [data-rc-prev/next/dot] sont lus, jamais reecrits.
   Le script est auto-neutralisant : il ne fait rien si la page ne contient ni
   .lpdp-delivery ni [data-lpdp-pack].
   ========================================================================== */
(function () {
  'use strict';

  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  /* ------------------------------------------------------------------------
     A. Date de livraison : jamais un samedi, jamais un dimanche.
     ------------------------------------------------------------------------ */
  function corrigerDateLivraison() {
    var p = document.querySelector('.lpdp-delivery');
    if (!p) return;
    var strong = p.querySelector('strong');
    if (!strong) return;

    var m = /([a-zéèêà]+)?\s*(\d{1,2})\/(\d{1,2})/i.exec(strong.textContent || '');
    if (!m) return;

    var jourAffiche = (m[1] || '').toLowerCase();
    var jj = parseInt(m[2], 10);
    var mm = parseInt(m[3], 10);

    var now = new Date();
    var an = now.getFullYear();
    // Passage d'annee : une date de livraison est toujours dans le futur proche.
    if (mm < now.getMonth() + 1) an += 1;

    var d = new Date(an, mm - 1, jj);
    if (isNaN(d.getTime())) return;

    // Report sur le jour ouvre suivant : 0 = dimanche, 6 = samedi.
    var reporte = false;
    while (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
      reporte = true;
    }

    var jourExact = JOURS[d.getDay()];
    // On ne reecrit que si la valeur rendue est fausse : week-end, ou nom de
    // jour incoherent avec la date.
    if (!reporte && jourAffiche === jourExact) return;

    var dd = ('0' + d.getDate()).slice(-2);
    var MM = ('0' + (d.getMonth() + 1)).slice(-2);
    strong.textContent = jourExact + ' ' + dd + '/' + MM;
    p.setAttribute('data-lovi-lot20-date', reporte ? 'reportee' : 'jour-corrige');
  }

  /* ------------------------------------------------------------------------
     B. Un seul palier selectionne, toujours.
     ------------------------------------------------------------------------ */
  function verrouillerSelectionUnique() {
    var packs = document.querySelectorAll('[data-lpdp-pack]');
    if (!packs.length) return;

    function normaliser(cible) {
      var liste = document.querySelectorAll('[data-lpdp-pack]');
      var i;
      // Si un seul palier est marque, on ne touche a rien.
      var selectionnes = document.querySelectorAll('[data-lpdp-pack].is-selected');
      if (selectionnes.length <= 1) return;
      for (i = 0; i < liste.length; i++) {
        if (liste[i] !== cible) liste[i].classList.remove('is-selected');
      }
      if (cible && !cible.classList.contains('is-selected')) {
        cible.classList.add('is-selected');
      }
    }

    for (var i = 0; i < packs.length; i++) {
      (function (el) {
        el.addEventListener('click', function () {
          // Apres le gestionnaire existant, jamais a sa place.
          setTimeout(function () { normaliser(el); }, 0);
        }, false);
      })(packs[i]);
    }
  }

  function init() {
    try { corrigerDateLivraison(); } catch (e) {}
    try { verrouillerSelectionUnique(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();